/**
 * public routes
 * @type {string[]}
 */
export const publicRoutes = [
    "/", "/images/phoneHomePage.png","/images/tws2white.png", "/redirect"
]

/**
 * uses for authtentication
 * @type {string[]}
 */
export const authRoutes = [
    "/auth/login", "/auth/register"
]

/**
 * the prefix form api autehnttication routes
 * routes that start with the prefix are use form api
 * @type {string}
 */
export const apiAuthPrefix = "/api/auth"

/**
 * RUTA 
 * 
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT = "/"

